import { IAddress } from '@netfront/common-library';

const getAddressLine = ({ city, line1, postcode, suburb, state }: IAddress) => {
  return [line1, suburb, state, postcode, city].filter((addressParts) => addressParts).join(', ');
};

export { getAddressLine };
